var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.722 17.498H2.277a.833.833 0 01-.721-1.25L9.277 2.915a.833.833 0 011.443 0l7.722 13.333a.833.833 0 01-.721 1.25zm-8.555-4.166v1.666h1.665v-1.666zm0-5.834v4.167h1.666V7.498z",
    fill: "#f2b14f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncFailed);
export default __webpack_public_path__ + "static/media/sync_failed.2465b878415e042e5489e3730add3c07.svg";
export { ForwardRef as ReactComponent };